import React, { useEffect } from 'react';
import { EventNotificationService } from '../../framework/services/event-notification';
import { AppMenuEvents } from '../../events/app-menu';

export const HomePage: React.FunctionComponent = () => {

  useEffect(() => {
    EventNotificationService.dispatch(AppMenuEvents.MenuUnavailable);
  }, []);


  return (
    <div>
      Hello there &ndash; I am awake!
    </div>
  );
};
